import { TabStyles } from '@tableau/widgets';
import * as _ from 'underscore';
import { cssClass } from '../../../style';
import { PermissionsGridStyles } from './PermissionsGridStyle';

export namespace AddNewPermissionStyles {
  export const addNewPermissionCssPrefix = 'AddNewPermission';
  export const buttonContainer = 'button-container';
  export const ButtonTopMargin = 12;

  export type AddNewPermissionContainerStyleArgs = {
    numAddedRows: number;
    numRows: number;
    inEditMode: boolean;
    searching: boolean;
  };

  export let memoizedButtonContainer = _.memoize(ButtonContainer, (args) => { return JSON.stringify(args); });
  export function ButtonContainer(args: AddNewPermissionContainerStyleArgs): string {
    let marginTop = ButtonTopMargin;
    // if extra rows were added to the permissions grid, a negative margin needs to be added to the AddPermission
    // so that it does not get forced downwards
    if (args.searching) {
      if (args.numAddedRows === 2) {
        marginTop = ButtonTopMargin - PermissionsGridStyles.RowHeight * (args.numAddedRows);
      } else {
        let numAboveMaxRows = 0;
        if (args.numRows - 2 > PermissionsGridStyles.MaxRows) {
          numAboveMaxRows = args.numRows - 2 - PermissionsGridStyles.MaxRows;
        }
        marginTop = ButtonTopMargin - PermissionsGridStyles.RowHeight * (args.numAddedRows + numAboveMaxRows);
      }
    } else if (args.inEditMode && args.numAddedRows === 1) {
      marginTop = ButtonTopMargin - PermissionsGridStyles.RowHeight * (args.numAddedRows);
    }
    return cssClass(addNewPermissionCssPrefix, buttonContainer, {
      marginTop: `${marginTop}px`,
    });
  }

  export const ButtonContent = cssClass(addNewPermissionCssPrefix, 'button-content', {
    alignItems: 'center',
    display: 'inline-flex',
    verticalAlign: 'middle',
  });
}
